<template>
    <div class="scr-body">
        <div class="section-container">
            <section class="sec-welcome">
                <div>
                    <h2>Hello!</h2>
                    <p>Welcome to DXC Sofia</p>
                </div>
                <div>
                    <button @click="showModal" class="btn">
                        <i class="icon-arrow-right"></i> Visit Objectives
                    </button>
                </div>
            </section>
            <section class="sec-day-switcher">
                <div>
                    <!-- Add class active to currently selected date -->
                    <button
                        v-for="eventDay in eventDays"
                        :key="eventDay.date"
                        :class="['day-button', isSelectedDate(eventDay)? 'active': '']"
                        @click="selectDate(eventDay.date)"
                    >
                        <b>{{eventDay.dayOfWeek}}</b>
                        <span>{{eventDay.date}}</span>
                    </button>
                </div>
            </section>
        </div>
        <section class="sec-event-list">
            <div
                v-for="(event, index) in currentDayEvents"
                :key="index"
                :class="['event-item', hasEventPassed(event)? 'past': '', isEventCurrent(event) ? 'current':'']"
            >
                <div class="event-time">
                    <b class="event-start-time">{{event.dateTime | moment("HH:mm")}}</b>
                    <span class="event-duration">{{event.duration}} min</span>
                </div>
                <div class="event-dot"></div>
                <div class="event-desc">
                    <h2>{{event.name}}</h2>
                    <p v-if="event.description">{{event.description}}</p>
                    <div v-if="event.location" class="event-location">{{event.location}}</div>
                    <!-- TODO: Add maps navigation-->
                    <div>
                        <a class="btn-text" href="#">
                            <i class="icon-pin"></i> Open in maps
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";
import mockData from "../store/mockData.json";
import moment from "moment";
import VueScrollTo from "vue-scrollto";
//This component shows the schedule for a visit in a list view.
export default {
    name: "VisitSchedule",
    data() {
        return {
            visitID: "",
            mockData: mockData,
            selectedDate: null,
            weather: []
        };
    },
    methods: {
        //TODO: Accept arguments
        navigateTo(latitude, longitude) {
            if (
                /* if we're on iOS, open in Apple Maps */
                navigator.platform.indexOf("iPhone") != -1 ||
                navigator.platform.indexOf("iPad") != -1 ||
                navigator.platform.indexOf("iPod") != -1
            )
                window.open(
                    `maps://maps.google.com/maps?daddr=${latitude},${longitude}&amp;ll=`
                );
            /* else use Google */ else
                window.open(
                    `https://maps.google.com/maps?daddr=${latitude},${longitude}&amp;ll=`
                );
        },
        checkVisit() {
            if (this.$route.params.id) {
                let visitID = this.$route.params.id;
                let foundVisit = false;
                this.mockData.visits.forEach(visit => {
                    if (visit.id === visitID) {
                        foundVisit = true;
                        this.$store.commit("changeID", visitID);
                    }
                });
                if (!foundVisit) {
                    // TODO: Fallback route or redirect?
                    this.$router.push("/404");
                }
                this.visitID = visitID;
            } else {
                if (this.$store.getters.visitID) {
                    this.visitID = this.$store.getters.visitID;
                } else {
                    this.$router.push("/404");
                }
            }
        },
        exportToCalendar(event) {
            // TODO: iOS not working; needs ICS files
            if (
                /* if we're on iOS, open in Apple Maps */
                navigator.platform.indexOf("iPhone") != -1 ||
                navigator.platform.indexOf("iPad") != -1 ||
                navigator.platform.indexOf("iPod") != -1
            ) {
            } else {
                window.open(
                    `https://www.google.com/calendar/render?action=TEMPLATE&text=${event.name}&details=${event.description}&location=${event.location}&dates=${event.startTime}%${event.endTime}`
                );
            }
        },
        isSelectedDate(day) {
            return day.date === this.selectedDate;
        },
        selectDate(date) {
            this.selectedDate = date;
        },
        hasEventPassed(event) {
            if (!this.isEventCurrent(event)) {
                return moment(event.dateTime, "YYYY-MM-DD HH:mm").isBefore(
                    moment()
                );
            } else {
                return false;
            }
        },
        isEventCurrent(event) {
            if (
                moment(event.dateTime, "YYYY-MM-DD HH:mm").isBefore(moment()) &&
                moment().isBefore(
                    moment(event.dateTime, "YYYY-MM-DD HH:mm").add(
                        parseInt(event.duration),
                        "minutes"
                    )
                )
            ) {
                return true;
            }
        },
        showModal() {
            this.$router.push("/objectives");
        }
    },
    computed: {
        currentVisit() {
            let current = null;
            this.mockData.visits.forEach(visit => {
                if (visit.id === this.visitID) {
                    current = visit;
                    this.$store.commit("newVisit", visit);
                }
            });
            return current;
        },
        events() {
            let events = [];
            if (this.currentVisit) {
                events = this.currentVisit.events;
            }
            return events;
        },
        currentDayEvents() {
            let currentEvents = [];
            if (this.events.length != 0 && this.selectedDate) {
                this.events.forEach(event => {
                    if (
                        moment(event.dateTime, "YYYY-MM-DD HH:mm").format(
                            "DD"
                        ) === this.selectedDate
                    ) {
                        currentEvents.push(event);
                    }
                });
            }
            return currentEvents;
        },
        eventDays() {
            let eventDays = [];
            let dates = [];
            for (let index = 0; index < this.events.length; index++) {
                let dateTime = moment(
                    this.events[index].dateTime,
                    "YYYY-MM-DD HH:mm"
                );
                if (!dates.includes(dateTime.format("DD"))) {
                    if (!this.selectedDate) {
                        this.selectedDate = dateTime.format("DD");
                    }
                    dates.push(dateTime.format("DD"));
                    eventDays.push({
                        dayOfWeek: dateTime.format("dd"),
                        date: dateTime.format("DD")
                    });
                }
            }
            return eventDays;
        }
    },
    mounted() {
        this.checkVisit();
        // Fired when the component is ready. <br/> Emitted for the Header to be changed to the correct title.
        // @arg The argument is a `String` value representing the current title.
        this.$emit("changed", "Schedule");
    },
    created() {
        // this.getWeather();
    },
    updated() {
        VueScrollTo.scrollTo(".current", 1500, { offset: -400 });
    }
};
</script>

<style >
</style>
